module.exports = __webpack_public_path__ + "static/media/logo.681b0b08.svg";